import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AxiosError } from "axios";
import { PlacementInfo } from "features/Entity/PlacementInfo";
import { downloadPlacementInfoDocumentRep, getPlacementApplicationFormFileRep, getPlacementInfoRep } from "features/Repository/PlacementInfoRepository";
import { AppThunk } from "../../app/store";
import saveAs from "file-saver";

interface PlacementInfoState {
  isRequesting: boolean;
  isRequestSuccess: boolean;
  isRequestFailed: boolean;
  error: AxiosError | null;
  placementInfo: PlacementInfo | null;
}

const initialState: PlacementInfoState = {
  isRequesting: false,
  isRequestSuccess: false,
  isRequestFailed: false,
  error: null,
  placementInfo: null
};

function startRequestRdc(state: PlacementInfoState) {
  state.isRequesting = true;
  state.isRequestFailed = false;
  state.error = null;
}

function requestFailedRdc(state: PlacementInfoState, action: PayloadAction<AxiosError>) {
  state.isRequesting = false;
  state.isRequestSuccess = false;
  state.isRequestFailed = true;
  state.error = action.payload;
}

function requestSuccessRdc(state: PlacementInfoState, action: PayloadAction<PlacementInfo>) {
  state.isRequesting = false;
  state.isRequestSuccess = true;
  state.isRequestFailed = false;
  state.error = null;
  state.placementInfo = action.payload;
}

const PlacementInfoSlice = createSlice({
  name: "placementInfo",
  initialState: initialState,
  reducers: {
    startRequestAct: startRequestRdc,
    requestFailedAct: requestFailedRdc,
    requestSuccessAct: requestSuccessRdc
  }
});

export const {
  startRequestAct,
  requestFailedAct,
  requestSuccessAct
} = PlacementInfoSlice.actions;

export default PlacementInfoSlice.reducer;

export const getPlacementInfo = (applicationFormUid: string): AppThunk => async dispatch => {
  try {
    dispatch(startRequestAct());
    const apiResponse = await getPlacementInfoRep(applicationFormUid);
    dispatch(requestSuccessAct(apiResponse));
  } catch (err) {
    dispatch(requestFailedAct(err as AxiosError));
  }
};

export const downloadPlacementInfoDocument = (placementDocumentUid: string, placementDocumentName: string): AppThunk => async dispatch => {
  try {
    const apiResponse = await downloadPlacementInfoDocumentRep(placementDocumentUid, placementDocumentName);
    saveAs(apiResponse.fileBlob, apiResponse.filename);
  } catch (err) {
    dispatch(requestFailedAct(err as AxiosError));
  }
};

export const getPlacementApplicationFormFile = (placementInfoUid: string, applicationformFileName: string): AppThunk => async dispatch => {
  try {
    const apiResponse = await getPlacementApplicationFormFileRep(placementInfoUid,applicationformFileName);
    saveAs(apiResponse.fileBlob, apiResponse.filename);
  } catch (err) {
    dispatch(requestFailedAct(err as AxiosError));
  }
};
